import React, { useMemo } from 'react';
import { Spinner, TableList } from 'seagull';
import { useStore } from "../../../store/store-context";
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import { useStoreActions } from "../../../contexts";
import GenericError from "../../../components/GenericError/GenericError";
import EditDraftsTableRow from "./EditDraftsTableRow";
import { editDraftsTableHeaderColumnDefs } from "./EditDraftsTable.utils";
import keyBy from 'lodash/keyBy';
function EditDraftsTableWithData(_ref) {
  let {
    drafts,
    loading,
    visibleColumns
  } = _ref;
  const contactsData = useStore(state => state.contacts.data);
  const headerItems = editDraftsTableHeaderColumnDefs(visibleColumns);
  const contactMap = useMemo(() => keyBy(contactsData || [], c => c.id()), [contactsData]);
  function getContact(draft) {
    return draft.clientContactId ? contactMap[draft.clientContactId] || null : null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "edit-drafts-table"
  }, /*#__PURE__*/React.createElement(TableList.Provider, {
    hasActionColumn: true,
    columnDefs: headerItems,
    enableRowSelection: true
  }, /*#__PURE__*/React.createElement(TableList.Structure, {
    header: /*#__PURE__*/React.createElement(TableList.Header, {
      stickyToTop: true,
      items: headerItems
    }),
    content: loading ? /*#__PURE__*/React.createElement(Spinner, {
      centeredInBox: true
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, drafts.map((draft, index) => /*#__PURE__*/React.createElement(EditDraftsTableRow, {
      key: draft.id,
      draft: draft,
      index: index,
      visibleColumns: visibleColumns,
      getContact: getContact
    })))
  })));
}
const EditDraftsTable = _ref2 => {
  let {
    visibleColumns
  } = _ref2;
  const {
    api
  } = useStoreActions();
  const fetchDrafts = () => api.draft.getFullDrafts({
    limit: 1000,
    page: 1
  });
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: fetchDrafts,
    renderLoader: () => /*#__PURE__*/React.createElement(Spinner, {
      centeredInBox: true,
      "data-testid": "edit-drafts-table-spinner"
    }),
    renderError: () => /*#__PURE__*/React.createElement(GenericError, {
      testid: "edit-drafts-table-error"
    }),
    renderChild: _ref3 => {
      let {
        data,
        loading
      } = _ref3;
      return /*#__PURE__*/React.createElement(EditDraftsTableWithData, {
        drafts: data,
        loading: loading,
        visibleColumns: visibleColumns
      });
    }
  });
};
export default EditDraftsTable;